import type { SupportMessage } from "./supportMessages";
import { isSupportMessage } from "./supportMessages.ts";

export type SupportAccountType = "user" | "vendor";

interface SupportAccountState {
  user: { user: { _id: string } | null; token: string | null; customerCareChatId: string | null; customerCareMessages: SupportMessage[] };
  vendor: { vendor: { _id: string } | null; token: string | null; customerCareChatId: string | null; customerCareMessages: SupportMessage[] };
}

export interface SupportAccount {
  type: SupportAccountType;
  senderId: string;
  token: string;
  chatId: string | null;
  messages: SupportMessage[];
}

// Resolve every chat field from the same account, including when both logins persist.
export function selectSupportAccount(state: SupportAccountState, accountType?: SupportAccountType): SupportAccount | null {
  const getAccount = (type: SupportAccountType): SupportAccount | null => {
    const slice = state[type];
    const identity = type === "user" ? state.user.user : state.vendor.vendor;
    const storedMessages: unknown[] = Array.isArray(slice.customerCareMessages) ? slice.customerCareMessages : [];
    const messages = storedMessages.every(isSupportMessage) ? storedMessages : storedMessages.filter(isSupportMessage);
    return identity?._id && slice.token
      ? { type, senderId: identity._id, token: slice.token, chatId: slice.customerCareChatId, messages }
      : null;
  };

  if (accountType) return getAccount(accountType);
  let preferredType: string | null = null;
  try {
    preferredType = localStorage.getItem("accountType");
  } catch { /* Storage may be unavailable in private browsing. */ }
  if (preferredType === "user" || preferredType === "vendor") {
    const preferred = getAccount(preferredType);
    if (preferred) return preferred;
  }
  return getAccount("user") || getAccount("vendor");
}
